type ServerErrors = {
  property: string;
  children: ServerErrors[];
  constraints: { [key: string]: string };
};

type ServerErrorData = {
  statusCode: number;
  message: string;
  errors?: ServerErrors[];
};

/**
 * @description Parse validation error message from API response and extract the first constraint message
 *
 * @SADtrace SAD-003-1, SAD-003-3, SAD-003-4
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @param {ServerErrorData} data - API Error data containing validation errors
 *
 * @returns {string} Parsed error message string
 */
export const parseErrorMessage = (data: ServerErrorData): string => {
  if (Array.isArray(data.errors) && !!data.errors.length) {
    // Get the first message from the list of errors
    return String(Object.entries(data.errors[0].constraints)[0][1]);
  }

  return data.message;
};
